import {
  SelectedFilters,
  useCampaignStore,
} from '@lidea/shared/data-access/core';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { plotsApi } from '../../apis/plots-api';
import { plotKeys } from './../../keys/plot-keys';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface UsePlotsInBoundsProps {
  bounds: mapboxgl.LngLatBounds | null;
  selectedFilters: SelectedFilters;
  cluster: boolean;
  zoom: number;
  type?: string;
  enabled?: boolean;
}

export function usePlotsInBounds(props: UsePlotsInBoundsProps) {
  const campaignId = useCampaignStore((s) => s.campaignId);

  const isEnabled = useMemo(() => {
    if (!campaignId) {
      return false;
    }
    if (props.enabled === false) {
      return false;
    }
    if (props.enabled) {
      return true;
    }

    return props.bounds !== null;
  }, [props.bounds, props.enabled, campaignId]);

  const query = useQuery({
    queryKey: plotKeys.inBounds(
      props.bounds!,
      props.cluster,
      props.selectedFilters,
      props.zoom,
      props.type || '',
      campaignId
    ),
    // queryKey: plotKeys.inBound(),
    queryFn: () =>
      plotsApi.getInBounds(
        props.selectedFilters,
        props.bounds!,
        props.cluster,
        props.zoom,
        props.type || ''
      ),
    // disable cache
    gcTime: 0,
    enabled: isEnabled,
    placeholderData: keepPreviousData,
  });

  return query;
}

export default usePlotsInBounds;
